import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
class BasketApi {
    constructor() {
        this.addProductToBasket = (product, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/product/add`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.addBundleToBasket = (product, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/product/add/bundle`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.addProductToBasketAnalytics = (product, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/analytics/product/add`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.addBundleToBasketAnalytics = (bundle, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: bundle,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/analytics/product/add/bundle`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.addProductToBasketDtm = (product, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/dtm/product/add`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.addBundleToBasketDtm = (bundle, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: bundle,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/dtm/product/add/bundle`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.getBasket = (apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/token`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.getBasicBasket = (apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/basic`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.initiateBasketForShopLanding = (apiEndpoint, defaultRequestParams, shopNumber) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                params: Object.assign(Object.assign({}, defaultRequestParams), { shopNumber }),
                url: `${apiEndpoint}api/basket/landing`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.resetBasketForShopLanding = (apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/landing/clear`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.refreshCustomerVouchers = (apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/refresh/customer/vouchers`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.shopAndFictionalIdCheck = (apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/fictive/switch`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.updateLanguage = (language, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/lang?lang=${language}`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.updateQuantity = (product, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/product/update`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.reduceQuantity = (product, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/product/reduce-amount`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.removeProductFromBasket = (product, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/product/delete`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.removeProductFromBasketAnalytics = (product, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/analytics/product/delete`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.removeProductFromBasketDtm = (product, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/dtm/product/delete`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.updateBasketProductAnalytics = (product, quantity, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: Object.assign(Object.assign({}, defaultRequestParams), { quantity }),
                url: `${apiEndpoint}api/analytics/product/update`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.updateBasketProductDtm = (product, quantity, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: product,
                method: 'POST',
                params: Object.assign(Object.assign({}, defaultRequestParams), { quantity }),
                url: `${apiEndpoint}api/dtm/product/update`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.basketOverviewDtm = (apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/dtm/basket/overview`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        // let the backend check if the basket-items needs to be reserved again
        this.checkStockReservation = (apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/stock/reserve`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.merge = (abandonedBasketToken, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                params: Object.assign(Object.assign({}, defaultRequestParams), { abandonedBasketToken }),
                url: `${apiEndpoint}api/basket/merge`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.personalShoppingAdviceMerge = (personalShoppingAdviceBasketToken, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'PUT',
                params: Object.assign(Object.assign({}, defaultRequestParams), { personalShoppingAdviceBasketToken }),
                url: `${apiEndpoint}api/personalshoppingadvice/merge`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.personalShoppingAdviceSendMail = (email, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                params: Object.assign(Object.assign({}, defaultRequestParams), { email }),
                url: `${apiEndpoint}api/personalshoppingadvice/sendmail`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.postSavePoint = (apiEndpoint) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${apiEndpoint}api/basket/savepoint`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.addBulkProductsToBasket = (products, apiEndpoint, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: products,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiEndpoint}api/basket/product/add/bulk`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new BasketApi();
